export const SideTypes = {
  BUY: 'buy',
  SELL: 'sell'
};
